/* tslint:disable */
/* eslint-disable */
/**
 * Solid Slate
 * Booking, made easy
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BookingChanges } from './BookingChanges';
import {
    BookingChangesFromJSON,
    BookingChangesFromJSONTyped,
    BookingChangesToJSON,
    BookingChangesToJSONTyped,
} from './BookingChanges';
import type { OperationEnum } from './OperationEnum';
import {
    OperationEnumFromJSON,
    OperationEnumFromJSONTyped,
    OperationEnumToJSON,
    OperationEnumToJSONTyped,
} from './OperationEnum';

/**
 *
 * @export
 * @interface BookingDecision
 */
export interface BookingDecision {
    /**
     *
     * @type {OperationEnum}
     * @memberof BookingDecision
     */
    operation: OperationEnum;
    /**
     *
     * @type {BookingChanges}
     * @memberof BookingDecision
     */
    changes?: BookingChanges;
    /**
     *
     * @type {string}
     * @memberof BookingDecision
     */
    requestId?: string;
    /**
     *
     * @type {number}
     * @memberof BookingDecision
     */
    revision: number;
    /**
     *
     * @type {string}
     * @memberof BookingDecision
     */
    decisionNote?: string;
}



/**
 * Check if a given object implements the BookingDecision interface.
 */
export function instanceOfBookingDecision(value: object): value is BookingDecision {
    if (!('operation' in value) || value['operation'] === undefined) return false;
    if (!('revision' in value) || value['revision'] === undefined) return false;
    return true;
}

export function BookingDecisionFromJSON(json: any): BookingDecision {
    return BookingDecisionFromJSONTyped(json, false);
}

export function BookingDecisionFromJSONTyped(json: any, ignoreDiscriminator: boolean): BookingDecision {
    if (json == null) {
        return json;
    }
    return {

        'operation': OperationEnumFromJSON(json['operation']),
        'changes': json['changes'] == null ? undefined : BookingChangesFromJSON(json['changes']),
        'requestId': json['request_id'] == null ? undefined : json['request_id'],
        'revision': json['revision'],
        'decisionNote': json['decision_note'] == null ? undefined : json['decision_note'],
    };
}

  export function BookingDecisionToJSON(json: any): BookingDecision {
      return BookingDecisionToJSONTyped(json, false);
  }

  export function BookingDecisionToJSONTyped(value?: BookingDecision | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {

        'operation': OperationEnumToJSON(value['operation']),
        'changes': BookingChangesToJSON(value['changes']),
        'request_id': value['requestId'],
        'revision': value['revision'],
        'decision_note': value['decisionNote'],
    };
}
